const ResultsSkeleton = () => {
    return (
        <div>
            <div className="flex flex-row items-center gap-4 mb-6 bg-white rounded-[10px] py-[8px] px-[12px] animate-pulse">
                <div className="h-10 w-[180px] bg-lightBG rounded opacity-30"></div>
                <div className="h-10 w-[120px] bg-lightBG rounded opacity-30"></div>
                <div className="flex-1"></div>
                <div className="h-10 w-10 bg-lightBG rounded-full opacity-30"></div>
            </div>
            <ResultsContentSkeleton />
        </div>
    )
}

export default ResultsSkeleton

export const ResultsContentSkeleton = () => {
    return (
        <div className="bg-white rounded-[10px] py-6 px-[30px] animate-pulse w-full h-full">
            {/* Content cards skeleton */}
            <div className="flex flex-col gap-5 w-full">
                {[...Array(4)].map((_, idx) => (
                    <div key={idx} className="flex flex-col items-center w-full">
                        <div className="bg-[#F8F8FB] h-6 w-[200px] mb-[20px]"></div>
                        <div key={idx} className="bg-[#F8F8FB] rounded-xl p-5 flex flex-col gap-3 w-full">
                            {/* Title and stats */}
                            <div className="flex flex-row items-center justify-between">
                                <div className="h-5 w-[180px] bg-lightBG rounded opacity-50"></div>
                                <div className="h-5 w-[80px] bg-lightBG rounded opacity-30"></div>
                            </div>
                            {/* Description */}
                            <div className="h-4 w-[60%] bg-lightBG rounded opacity-30 mb-2"></div>
                            {/* Progress bar */}
                            <div className="w-full h-3 bg-lightBG rounded-full opacity-30"></div>
                            {/* Footer row */}
                            <div className="flex flex-row items-center justify-between mt-2">
                                <div className="h-4 w-[100px] bg-lightBG rounded opacity-30"></div>
                                <div className="h-4 w-[80px] bg-lightBG rounded opacity-30"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
